import { Collection } from 'backbone';
import { League } from '../../models';

/**
 * @desc Table
 * This Collection using for leagues
 */
class Leagues extends Collection {
	get model() {
		return League;
	}

	/**
	 * Method to get user leagues
	 * @param {object} data
	 * @returns {Promise.<Object>|*}
	 */
	show_my( data = {} ) {
		this.url = 'my_list';

		return this.fetch( { data } ).then( response => {
			let count_leagues = response.result.length;
			this.trigger('get:response:leagues:count', count_leagues);
		} );
	}

	/**
	 * Method to get joined leagues
	 * @returns {Leagues}
	 */
	showToJoin() {
		this.url = 'show_to_join';
		return this;
	}

	showJoinList( data = {}, remove = true ) {
		this.showToJoin();
		return this.fetch( { data, remove } ).then( response => {
			let count_leagues = response.result.length;
			this.trigger('get:response:leagues:count', count_leagues);
		} );
	}
}

export default Leagues;